export default {
  sidebar: {
    main: 'Main',
    dashboard: 'Dashboard',
    chat: 'Chat',
    preview: 'Preview',
    chatInterface: 'Chat interface',
    dataSources: 'Data Sources',
    dataSourcesWebsite: 'Website',
    dataSourcesFiles: 'Files',
    dataSourcesText: 'Text',
    dataSourcesFaq: 'FAQ',
    dataSourcesExternal: 'External',
    connections: 'Connections',
    connectionsWebsite: 'Website',
    connectionsWhatsapp: 'Whatsapp',
    trainingData: 'Training Data',
    data: 'Data',
    products: 'Products',
    content: 'Content',
    insights: 'Insights',
    inbox: 'Inbox',
    tickets: 'Tickets',
    leads: 'Leads',
    analytics: 'Analytics',
    chats: 'Chats',
    topics: 'Topics',
    chatLogs: 'Chat Logs',
    emailSettings: 'Email Settings',
    createChatbot: 'Create Chatbot',
    security: 'Security',
    workspace: 'Workspace',
    billing: 'Billing',
    profile: 'Profile',
  },
  topbar: {
    accountSettings: 'Account Settings',
  },
  account: {
    profile: 'Profile',
    fullName: 'Full Name',
    securityAndAccess: 'Security and Access',
    workspace: 'Workspace',
    billing: 'Billing',
    userInformation: 'User Information',
    email: 'E-Mail',
    firstName: 'First Name',
    lastName: 'Last Name',
    updateProfile: 'Update Profile',
    profileImage: 'Profile Image',
    uploadImage: 'Upload image',
    remove: 'Remove',
    uploadSupport: 'Supports JPG, PNG, and SVG files up to 1MB',
    dataPrivacy: 'Data privacy',
    cookies: 'Cookies',
    withdrawCookieConsent: 'Withdraw cookie consent',
    dangerZone: 'Danger zone',
    deleteAccount: 'Delete account',
    deleteYourAccount: 'Delete your account',
    password: 'Password',
    passwordDescription: 'Change your password to secure your account',
    setNewPassword: 'Set New Password',
    twoFactorAuth: 'Two-factor Authentication',
    twoFactorDescription: 'Add an extra layer of security to your account',
    enable: 'Enable',
    disable: 'Disable',
    workspaceManageMembers: 'Manage your team members and invite new',
    admin: 'Admin',
    member: 'Member',
    owner: 'Owner',
    viewer: 'Viewer',
    guest: 'Guest',
    user: 'User',

    // Security Status
    securityStatus: 'Security Status',
    securityStrong: 'Strong',
    securityMedium: 'Medium',
    securityWeak: 'Weak',
    securityLoading: 'Loading...',

    // Two Factor Status
    twoFactorEnabled: 'Enabled',
    twoFactorDisabled: 'Disabled',
    lastPasswordChange: 'Last changed',

    // Password Modal
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    changePassword: 'Change Password',

    // Two Factor Modal
    enableTwoFactorTitle: 'Enable Two-factor Authentication',
    disableTwoFactorTitle: 'Disable Two-factor Authentication',
    enableTwoFactorMessage: 'You will be redirected to set up two-factor authentication using an authenticator app. Do you want to continue?',
    disableTwoFactorMessage: 'Are you sure you want to disable two-factor authentication? This will reduce the security of your account.',
    continue: 'Continue',
    workspaceIdentification: 'Workspace Identification',
    workspaceName: 'Workspace Name',
    workspacePlaceholder: 'Workspace',
    yourTeam: 'Your Team',
    manageTeamMembers: 'Manage your team members and invite new',
    invite: 'Invite',
    editor: 'Editor',
    deleteWorkspace: 'Delete workspace',
    deleteWorkspaceWarning: 'Once you delete your workspace, there is no going back. Please be certain.',
    deleteYourWorkspace: 'Delete your workspace',
    confirmDelete: 'Confirm Delete',
    deleteConfirmationText: 'Are you sure you want to delete this item? This action cannot be undone.',

    // Team Management
    joinDate: 'Join Date',
    noTeamMembers: 'No team members',
    inviteTeamMember: 'Invite Team Member',
    enterTeamEmail: 'Enter email',
    role: 'Role',
    sendInvite: 'Send Invite',

    // Billing Information
    billingInformation: 'Billing Information',
    billingDescription: 'Is displayed on every invoice. Changes do not apply to invoices that have already been issued.',
    billingName: 'Billing Name',
    enterBillingName: 'Enter billing name',
    billingEmail: 'Billing Email',
    enterBillingEmail: 'Enter billing email',
    billingVatId: 'VAT ID',
    enterVatId: 'Enter VAT ID',
    yourStreet: 'Your Street',
    enterStreet: 'Enter street',
    yourZipCode: 'Your Zip Code',
    enterZipCode: 'Enter zip code',
    yourCity: 'Your City',
    enterCity: 'Enter city',
    yourCountry: 'Your Country',
    selectCountry: 'Select country',
    cancelChange: 'Cancel Change',
    saveChanges: 'Save Changes',
    vatId: 'VAT ID',
    address: 'Address',
    street: 'Street',
    zipCode: 'Zip Code',
    city: 'City',

    // Payment Methods
    paymentMethod: 'Payment Method',
    changePaymentMethod: 'Change Payment Method',
    creditCard: 'Credit Card',
    bankTransfer: 'Bank Transfer',
    cardNumber: 'Card Number',
    enterCardNumber: 'Enter card number',
    expiryDate: 'Expiry Date',
    cvv: 'CVV',
    enterCvv: 'Enter CVV',
    cardholderName: 'Cardholder Name',
    enterCardholderName: 'Enter cardholder name',
    paypalAccount: 'PayPal Account',
    paypalDescription: 'You will be redirected to PayPal to complete the payment',
    bankTransferInfo: 'Bank Transfer Information',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    routingNumber: 'Routing Number',
    swiftCode: 'SWIFT Code',
    savePaymentMethod: 'Save Payment Method',

    // Invoices
    invoices: 'Invoices',
    invoicesDescription: 'All invoices for your plan.',
    noInvoices: 'No invoices found.',
    invoiceId: 'Invoice ID',
    invoiceDate: 'Invoice Date',
    plan: 'Plan',
    amount: 'Amount',
    status: 'Status',
    download: 'Download',
    downloadInvoice: 'Download Invoice',
    invoiceStatusPaid: 'Paid',
    invoiceStatusPending: 'Pending',
    invoiceStatusFailed: 'Failed',
    invoiceStatusCancelled: 'Cancelled',
    invoiceStatusUnknown: 'Unknown',

    // User Tour
    userTour: {
      title: 'User Tour',
      description: 'Enable or disable guided tours throughout the application to help you navigate and learn the features.',
      enable: 'Enable Tour',
      disable: 'Disable Tour',
    },
  },

  // Authentication Pages
  auth: {
    // Common
    emailAddress: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loading: 'Loading...',
    processing: 'Processing...',
    back: 'Back',

    // Login page
    loginTitle: 'Welcome Back',
    loginSubtitle: 'Sign in to your account',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPasswordLink: 'Forget Password?',
    signIn: 'Sign In',
    dontHaveAccount: "Don't have an account?",
    registerLink: 'Register',
    pleaseEnterValidDetails: 'Please enter valid details',
    loggingIn: 'Logging in...',

    // Register page
    registerTitle: 'Create Account',
    registerSubtitle: 'Create your account',
    fullName: 'Full Name',
    enterFullName: 'Enter your full name',
    enterEmailAddress: 'Enter your email address',
    passwordHint: 'Password must be at least 6 characters',
    agreeTerms: 'I agree to the Terms and Conditions',
    iAgreeToThe: 'I agree to the',
    termsAndConditions: 'Terms and Conditions',
    register: 'Register',
    alreadyHaveAccount: 'Already have an account?',
    loginLink: 'Login',
    pleaseAgreeToTheTermsAndConditions: 'Please agree to the terms and conditions',
    passwordMustBeAtLeast6Characters: 'Password must be at least 6 characters',
    pleaseFillInAllInformation: 'Please fill in all information',
    registrationSuccessful: 'Registration successful! Redirecting to dashboard...',
    registrationSuccessfulPleaseLogin: 'Registration and workspace setup completed successfully! Please login to continue.',
    registrationSuccessCheckEmail: 'Registration successful! Please check your email to verify your account.',
    pleaseWaitRedirecting: 'Please wait while we redirect you to the login page...',
    registrationError: 'An error occurred during registration. Please try again.',
    registrationWithProviderFailed: 'Registration with {provider} failed',

    // Auth Callback page
    finalizingAuthentication: 'Finalizing Authentication',
    settingUpWorkspace: 'Setting Up Workspace',
    authenticationComplete: 'Authentication Complete',
    authenticationFailed: 'Authentication Failed',
    pleaseWaitAuthenticating: 'Please wait while we authenticate your account...',
    pleaseWaitSettingUpWorkspace: 'Please wait while we set up your workspace...',
    redirectingToDashboard: 'Redirecting to dashboard...',
    workspaceCreatedSuccessfully: 'Workspace created successfully!',
    welcomeBack: 'Welcome back! Redirecting to your workspace...',
    tryAgain: 'Try Again',

    thisEmailIsAlreadyRegistered: 'This email is already registered',
    invalidEmail: 'Invalid email',
    emailNotConfirmed: 'Email not confirmed',
    invalidCredentials: 'Invalid credentials',
    tooManyRequestsPleaseTryAgainLater: 'Too many requests, please try again later',
    anErrorOccurredPleaseRetry: 'An error occurred, please try again',

    // Recover password page
    recoverPasswordTitle: 'Reset Password',
    recoverPasswordSubtitle: 'Enter your email to reset password',
    sendResetLink: 'Reset Password',
    sending: 'Sending...',
    backToLogin: 'Back to',
    logIn: 'Log In',

    // Reset password page
    setNewPasswordTitle: 'Set New Password',
    newPassword: 'New Password',
    enterNewPassword: 'Enter new password',
    confirmNewPassword: 'Confirm new password',
    updatePassword: 'Update Password',
    updating: 'Updating...',
    goToLogin: 'Go to Login',

    // Social login
    continueWithGoogle: 'Google',
    orDivider: 'Or',

    // Validation messages
    validEmailRequired: 'Please enter a valid email address',
    passwordMinLength: 'Password must be at least 6 characters long',
    passwordsDoNotMatch: 'Passwords do not match',

    // Success/Error messages
    resetLinkSent: 'A password reset link has been sent to {email}. Please check your email and follow the instructions to reset your password.',
    passwordResetSuccess: 'Your password has been updated successfully! You can now log in with your new password.',
    resetLinkError: 'An error occurred while sending reset email',
    updatePasswordError: 'An error occurred while updating password',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    invalidResetLink: 'Invalid or expired reset link. Please request a new password reset.',
    sessionCheckError: 'Unable to verify reset link. Please try again.',
    sessionExpired: 'Your session has expired. Please log in again.',
    sessionError: 'An error occurred with your session. Please log in again.',
  },

  comingSoon: {
    title: 'Coming Soon',
    description: 'We are making the system better.',
  },

  welcome: {
    title: 'Welcome to Sellbase',
    subtitle: 'What would you like to do today?',
    newChatBot: 'Create new',
    createFirst: 'Create your first ChatBot',
    noChatbots: 'No chatbots available',
    limitReachedTooltip: 'You can only create a maximum of 1 chatbot.',
  },
  onboarding: {
    title: 'New ChatBot',
    steps: {
      basicInfo: 'Basic Information',
      dataSources: 'Data Sources',
      chatInterface: 'Chat Interface',
    },
    step1: {
      description:
        'This setup guide will assist you with the initial configuration of your chatbot. Once the bot has been created, you can change and add to the settings later.',
      internalNameLabel: 'Internal Chatbot Name',
      internalNamePlaceholder: 'My first ChatBot',
      displayNameLabel: 'Display Name of your Chatbot',
      displayNamePlaceholder: 'James Bot',
      descriptionLabel: 'Chatbot Description',
      descriptionPlaceholder: 'Description',
      checking: 'Checking for setup chatbot...',
      limitReached: 'You have reached the maximum limit of 1 chatbot per tenant.',
      manageExisting: 'Please manage your existing chatbot from the dashboard.',
      limitReachedTitle: 'Chatbot Limit Reached',
      backToDashboard: 'Back to Dashboard',
    },
    step2: {
      description:
        'To ensure that your ChatBot knows what to talk about. Your online store serves as foundation for this, which means it needs the URL or a sitemap.',
      description2:
        'When you have completed the initial configuration, you can train your ChatBot with additional information from files, documents and your own text entries.',
      urlTitle: 'Your Online Shop URL',
      urlPlaceholder: 'my-shop.de',
      urlDescription:
        'This will crawl all the links starting with the URL (not including files on the website).',
      fetchButton: 'Fetch Website',
      sitemapTitle: 'Submit Sitemap',
      sitemapPlaceholder: 'my-shop.de/sitemap.xml',
      urlDescriptionSitemap: 'The sitemap XML is retrieved from the URL, parsed and used for crawling.',
      loadButton: 'Load sitemap',
      foundLinkTile: 'Found Links',
      failLinkTile: 'Failed Links',
      addUrlTitle: 'Add New URL',
      addUrl: 'URL-Liste hinzufügen',
      addListUrl: {
        title: 'Add List of URLs',
        placeholder: 'Enter each URL on a new line...',
        invalidUrls: 'The following URLs are invalid',
        processing: 'Processing URL list...',
        success: 'Added {count} URLs as a new source.',
        noUrls: 'No valid URLs were added.',
        error: 'Error adding URLs: ',
      },
      fetchSuccess: 'Website source added',
      fetchError: 'Error fetching website: ',
      sitemapSuccess: 'Sitemap source added',
      sitemapError: 'Error loading sitemap: ',
    },
    step3: {
      description:
        'This is where you define what your ChatBot looks like. With the preview you can also try it out directly.',
      messages: 'Messages',
      welcomeMessage: 'Welcome Message',
      suggestedMessages: 'Suggested Messages',
      messagePlaceholder: 'Message...',
      enterNewLine: 'Enter each message on a new line.',
      visualAppearance: 'Visual Appearance',
      theme: 'Theme',
      themes: {
        light: 'Light',
        dark: 'Dark',
      },
      avatarImage: 'Avatar Image',
      chatIcon: 'Chat Icon',
      uploadImage: 'Upload Image',
      remove: 'Remove',
      imageSupport: 'Supports JPG, PNG, and SVG files up to 1MB',
      userMessageColor: 'User message color',
      chatButtonColor: 'Chat bubble color',
      headerColor: 'ChatBox header color',
      reset: 'Reset',
      chatAlignment: 'Chat Alignment',
      alignments: {
        left: 'Left',
        right: 'Right',
      },
      miscellaneous: 'Miscellaneous',
      autoShowWelcome: 'Auto show welcome messages pop-ups after',
      seconds: 'seconds',
      negativeToDisable: '(negative to disable)',
      preview: 'Preview',
      launchChatBot: 'Launch ChatBot',
      defaultWelcomeMessage: 'Hi, how can I help you?',
      defaultMessagePlaceholder: 'Message...',
    },
    result: {
      title: 'Chatbot Preview',
      description: 'Hooray! My First ChatBot is ready to go. Here are the next steps you can do.',
      webshopTitle: 'Place it on your Webshop',
      getCode: 'Get the code',
      dataSources: 'Fine tune the data sources',
      uploadData: 'Upload additional data',
      visualTitle: 'Change the visual appearance',
      changeAppearance: 'Style it',
      preview: 'Preview',
      messagePlaceholder: 'Message...',
    },
  },
  common: {
    back: 'Back',
    continue: 'Continue',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    deleteAll: 'Delete all',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    copy: 'Copy',
    show: 'Show',
    hide: 'Hide',
    clickToEdit: 'Click to edit',
    chatAssistant: 'Chat Assistant',
    totalLinks: 'Total links: {count}',
    copySuccess: 'Copied to clipboard',
    error: 'Error: ',
    loading: 'Loading...',
    filter: 'Filter',
    refresh: 'Refresh',
    search: 'Search',
    activeForBot: 'Active for Bot',
    add: 'Add',
    // Additional translations for external functionality
    clearAll: 'Clear All',
    addMore: 'Add More',
    deleteSelected: 'Delete Selected',
    status: 'Status',
    createdAt: 'Created At',
    actions: 'Actions',
    loadMore: 'Load More',
    selectAll: 'Select All',
    of: 'of',
    deleted: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    open: 'Open',
    justNow: 'Just now',
  },
  products: {
    title: 'Product data',
    description:
      'This will fetch the sitemap XML from the provided URL, parse it to extract all contained URLs, and use these URLs as the basis for crawling.',
    columns: {
      id: 'Item #',
      category: 'Category',
      name: 'Product Name',
      lastUpdate: 'Last update',
    },
    detail: {
      title: 'Product Details',
      editTitle: 'Edit Product',
      itemNo: 'Item No.',
      category: 'Category',
      price: 'Price',
      name: 'Product Name',
      shortDescription: 'Short Description',
      longDescription: 'Long Description',
      sku: 'SKU',
      weight: 'Weight',
      dimensions: 'Dimensions',
      material: 'Material',
      features: 'Features',
      images: 'Images'
    }
  },
  content: {
    title: 'Content data',
    description:
      'List of training data defined as content. You can check and correct the information or convert it to products.',
    columns: {
      id: 'Item #',
      mainHeadline: 'Main Headline',
      lastUpdate: 'Last update',
      name: 'Name',
      category: 'Category',
      status: 'Status',
    },
    loadSuccess: 'Content loaded successfully',
    loading: 'Loading...',
    noContents: 'No contents found',
    noContentsFound: 'No contents found',
    noContentsFoundDescription: 'Do not have any content',
    noContentsFoundIcon: 'mgc_article_line',
    loadingContents: 'Loading contents...',
    detail: {
      title: 'Content Details',
      editTitle: 'Edit Content',
      texts: 'Texts',
      images: 'Images',
      mainHeadline: 'Main Headline',
      contentText: 'Content Text',
      pageType: 'Page Type',
      language: 'Language',
      contentUrl: 'Content URL',
      usedByChatbots: 'Used by Chatbots',
      noImagesAvailable: 'No images available',
      moreImages: '+{count} more images'
    }
  },
  chat: {
    preview: {
      title: 'Preview',
      description:
        'The playground for your chat bot. You also define the basic settings here and you can delete single bots.',
      internalNameLabel: 'Internal Name of your Chat Bot',
      displayNameLabel: 'Display Name of your Chat Bot',
      previewTitle: 'Preview',
      messagePlaceholder: 'Message...',
      selectBot: 'Select chatbot',
      loadingChatbots: 'Loading chatbots...',
      chatbotsLoaded: 'Chatbots loaded successfully',
      noChatbotsAvailable: 'No chatbots available',
      loadingChatbot: 'Loading chatbot...',
      chatbotLoaded: 'Chatbot loaded successfully',
      error: 'Error: ',
      save: 'Save changes',
      saving: 'Saving changes...',
      saveSuccess: 'Changes saved successfully',
      saveError: 'Error saving changes: ',
      noSelection: 'No chatbot selected',
      revisions: 'Revisions',
      deleteChatbot: 'Delete chatbot',
      sampleUserMessage: 'Hello, how are you?',
      refresh: 'Refresh data',

      defaultChatbotName: 'Chatbot',
      playgroundDescription: 'The playground for your chat bot. You also define the basic settings here and you can delete single bots.',
      chatbotNameLabel: 'Chatbot Name',
      namePlaceholder: 'Name',
      chatbotDescriptionLabel: 'Chatbot Description',
      descriptionPlaceholder: 'This is my first chat bot',
      saveChangesButton: 'Save changes',
      revisionsButton: 'Revisions',
      deleteChatbotButton: 'Delete chatbot',

      // Additional keys for save/delete functionality
      invalidForm: 'Please fill in required fields',
      deleting: 'Deleting chatbot...',
      deleteSuccess: 'Chatbot deleted successfully',
      deleteError: 'Error deleting chatbot: ',
      confirmDelete: 'Are you sure you want to delete this chatbot? This action cannot be undone.',
    },
    interface: {
      title: 'Chat Interface',
      description:
        'Here you can configure your chat interface, change messages, colors and more settings',
      messages: 'Messages',
      welcomeMessage: 'Welcome Message',
      suggestedMessages: 'Suggested messages',
      messagePlaceholder: 'Message placeholder',
      enterNewLine: 'Enter each message in a new line.',
      visualAppearance: 'Visual appearance',
      theme: 'Theme',
      themes: {
        light: 'Light',
        dark: 'Dark',
      },
      avatarImage: 'Avatar Image',
      chatIcon: 'Chat Icon',
      uploadImage: 'Upload image',
      remove: 'Remove',
      imageSupport: 'Supports JPG, PNG, and SVG files up to 1MB',
      userMessageColor: 'User message color',
      chatButtonColor: 'Chat bubble color',
      headerColor: 'ChatBox header color',
      reset: 'Reset',
      chatAlignment: 'Chat Alignment',
      alignments: {
        left: 'Left',
        right: 'Right',
      },
      miscellaneous: 'Miscellaneous',
      autoShowWelcome: 'Auto show welcome messages pop-ups after',
      seconds: 'seconds',
      negativeToDisable: '(negative to disable)',
      preview: 'Preview',
    },
    connections: {
      title: 'Website Connection',
      description: 'Configure your website connection and embed the chatbot',
      connectionSettings: 'Connection Settings',
      storeUrl: 'Store URL',
      storeUrlPlaceholder: 'https://example-shop.com',
      accessToken: 'Access Token',
      authentication: 'Authentication',
      embedCode: 'Embed Code',
      embedDescription: 'Insert the following code into the header of your website to enable the chatbot',
      embedInstructions: {
        title: 'How to embed:',
        step1: 'Copy the code above',
        step2: 'Paste it into your website\'s <head> section',
        step3: 'The chatbot will appear on your website automatically'
      },
      copy: 'Copy',
      saveSuccess: 'Connection settings saved successfully',
      saveError: 'Error saving connection settings',
      embedCopySuccess: 'Embed code copied to clipboard',
      urlRequired: 'Store URL is required'
    },
    logs: {
      title: 'Chat Logs',
      description: 'View and analyze chat conversations between users and your chatbot.',
      searchPlaceholder: 'Search chat logs',
      filter: 'Filter',
      export: 'Export',
      noLogs: 'No chat logs found.',
      viewConversation: 'View conversation',
      back: 'Back to logs',
      date: 'Date',
      time: 'Time',
    },
  },
  dataSources: {
    common: {
      selectBot: 'Select a bot',
      chatBotName: 'Chat Bot {number}',
      of: 'of',
      urls: 'URLs',
      chatbotsLoaded: 'Chatbots loaded successfully',
      noChatbotsAvailable: 'No chatbots available',
      noChatbotSelected: 'No chatbot selected',
      loadingChatbots: 'Loading chatbots...',
      error: 'Error: ',
      loadingUrls: 'Loading trained URLs...',
      urlsLoaded: 'Trained URLs loaded successfully',
      fetchError: 'Error loading trained URLs: ',
      urlRequired: 'URL is required',
      selected: 'selected',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
    },
    website: {
      title: 'Website Data',
      description: 'You can either choose to use your URL or Sitemap',
      loadingChatbots: 'Loading chatbots...',
      chatbotsLoaded: 'Chatbots loaded successfully',
      noChatbotsAvailable: 'No chatbots available',
      error: 'Error: ',
      loadingUrls: 'Loading trained URLs...',
      urlsLoaded: 'Trained URLs loaded successfully',
      fetchError: 'Error loading trained URLs: ',
      urlRequired: 'URL is required',
      fetchingWebsite: 'Fetching website...',
      websiteFetched: 'Website fetched successfully! Found {0} new URLs.',
      sitemapRequired: 'Sitemap URL is required',
      loadingSitemap: 'Loading sitemap...',
      sitemapLoaded: 'Sitemap loaded successfully! Found {0} URLs.',
      loadError: 'Error loading sitemap: ',
      noMoreUrls: 'Functionality to load more URLs not available.',
      noUrlsToDelete: 'No URLs to delete',
      deletingAll: 'Deleting all URLs...',
      allDeleted: 'All URLs deleted successfully',
      deleteError: 'Error deleting URLs: ',
      deletingUrl: 'Deleting URL...',
      urlDeleted: 'URL deleted successfully',
      selectBot: 'Select chatbot',
      refresh: 'Refresh',
      confirmDeleteAllTitle: 'Confirm Delete All URLs',
      confirmDeleteAllMessage: 'Are you sure you want to delete all trained URLs? This action cannot be undone.',
      confirmDeleteUrlTitle: 'Confirm Delete URL',
      confirmDeleteUrlMessage: 'Are you sure you want to delete this URL? ',
      urlDescription: 'This will crawl all the links starting with the URL (not including files on the website).',
      urlPlaceholder: 'my-shop.de',
      fetchButton: 'Fetch Website',
      sitemapTitle: 'Submit Sitemap',
      sitemapPlaceholder: 'my-shop.de/sitemap.xml',
      loadButton: 'Load sitemap',
      trainedUrlsTitle: 'Trained URLs',
      noTrainedUrls: 'No trained URLs yet',
      loadingMoreUrls: 'Loading more URLs...',
      noMoreUrlsToLoad: 'No more URLs to load',
      urlDescriptionSitemap: 'The sitemap XML is retrieved from the URL, parsed and used for crawling.',
      linkSources: 'Link sources',
      foundUrlsTitle: 'Found URLs',
      noFoundUrls: 'No URLs found yet',
      lastCrawled: 'Last crawled',
      linksCount: 'Links:',
      linksIncluded: 'LINKS INCLUDED',
      websiteCrawledNew: 'Website crawled successfully. Found {count} URLs.',
      sitemapLoadedNew: 'Sitemap loaded successfully. Found {count} URLs.',
      loadMoreError: 'Error loading more URLs: ',
      noSourcesToTrain: 'No sources to train',
      trainingUrls: 'Training {count} sources...',
      trainingJobStarted: 'Training job started for {count} sources. Data will be updated soon.',
      urlsTrainedSuccessfully: '{count} URLs trained successfully',
      trainingFailed: 'Training failed: ',
      addingUrlList: 'Processing URL list...',
      addedUrlListResult: 'Added {count} URLs as a new source.',
      addedUrlListNone: 'No valid URLs were added',
      addUrlListError: 'Error adding URLs: ',
      batchAndTrain: 'Batch and Train',
      sourcesReady: 'source(s) ready to train',
      sourcesInfo: 'Website Sources',
      sourcesSelected: 'source(s) selected',
    },
    files: {
      title: 'Files',
      description: 'You can upload documents as training material for your bot.',
      dropAreaText: 'Drop files here or click to upload.',
      supportedFileTypes: 'Supported File Types: .pdf, .doc, .docx, .txt',
      uploadedFilesTitle: 'Uploaded Files',
      localFilesTitle: 'Selected Files',
      trainedFilesTitle: 'Trained Files',
      trainButton: 'Train new files',
      training: 'Training...',
      trainSuccess: 'Files trained successfully',
      trainError: 'Error training files: ',
      loadError: 'Error loading files: ',
      deleteSuccess: 'File deleted successfully',
      deleteError: 'Error deleting file: ',
      deleteAllError: 'Error deleting all files: ',
      localFilesCleared: 'Local files cleared',
      allTrainedDeleted: 'All trained files deleted',
      noFilesToTrain: 'No files to train',
      trainingFiles: 'Training files...',
      confirmDeleteLocalTitle: 'Delete Local Files',
      confirmDeleteLocalMessage: 'Are you sure you want to remove all selected files from the list? They have not been uploaded yet.',
      confirmDeleteTrainedTitle: 'Delete Trained Files',
      confirmDeleteTrainedMessage: 'Are you sure you want to delete all trained files? This will remove them from your chatbot training data.',
      removePendingSuccess: 'Files removed successfully',
      allFilesLoaded: 'All files loaded',
    },
    text: {
      title: 'Text Data Source',
      description: 'Just drop some lines you want your chatbot to use.',
      placeholder: 'Enter text...',
      titlePlaceholder: 'Enter title...',
      trainButton: 'Train New Text',
      trainedTextsTitle: 'Trained Texts',
      noTextsTrainedYet: 'No texts trained yet.',
      editingMode: 'Editing text',
      training: 'Training...',
      updating: 'Updating...',
      updateButton: 'Update Text',
      emptyText: 'Please enter title and content.',
      trainingText: 'Training text...',
      trainSuccess: 'Text trained successfully!',
      trainError: 'Error training text: ',
      updatingText: 'Updating text...',
      updateSuccess: 'Text updated successfully!',
      updateError: 'Error updating text: ',
      deletingText: 'Deleting text...',
      deleteSuccess: 'Text deleted successfully',
      deleteError: 'Error deleting text: ',
      noTextsToDelete: 'No texts to delete.',
      deletingAllTexts: 'Deleting all texts...',
      deleteAllSuccess: 'All texts deleted successfully',
      deleteAllError: 'Error deleting all texts: ',
      editing: 'Editing...',
      allTextsLoaded: 'All texts loaded',
      allTextsTitle: 'All Texts',
    },
    faq: {
      title: 'Q&A Data Source',
      description: 'Add frequently asked questions and their answers.',
      placeholder: 'Enter text...',
      questionLabel: 'Question',
      answerLabel: 'Answer',
      trainButton: 'Train FAQ',
      updateButton: 'Update Q&A',
      emptyFields: 'Please enter both question and answer.',
      training: 'Training FAQ...',
      updating: 'Updating Q&A...',
      trainSuccess: 'FAQ trained successfully!',
      trainError: 'Error training FAQ: ',
      updateSuccess: 'Q&A updated successfully!',
      updateError: 'Error updating Q&A: ',
      trainedQasTitle: 'Trained Q&As',
      noQasTrainedYet: 'No Q&As trained yet.',
      editing: 'Editing...',
      editingMode: 'Editing Q&A',
      updatingQa: 'Updating Q&A...',
      deleteSuccess: 'Q&A deleted successfully',
      deleteError: 'Error deleting Q&A: ',
      noQasToDelete: 'No Q&As to delete.',
      deletingQa: 'Deleting Q&A...',
      deletingAllQas: 'Deleting all Q&As...',
      deleteAllSuccess: 'All Q&As deleted successfully',
      deleteAllError: 'Error deleting all Q&As: ',
      addNewFaq: 'Add new FAQ',
      fillExistingFaqsFirst: 'Fill existing FAQs first',
    },
    external: {
      title: 'External knowledge',
      description: 'Here you can define external sources and keywords that help the chat bot to provide information on the specific topics of your shop. Useful options are Wikipedia entries or informative blogs.',
      urlLabel: 'External URL',
      urlPlaceholder: 'https://external-source.de',
      urlDescription: 'This will crawl all the links starting with the URL (not including files on the website).',
      keywordsLabel: 'Keywords',
      keywordsPlaceholder: 'Enter keyword ...',
      keywordsDescription: 'Separate individual keywords with comma',
      fetchButton: 'Fetch Website',
      fetching: 'Fetching website...',
      fetchSuccess: 'Website fetched successfully',
      fetchError: 'Error fetching website: ',
      keywordsRequired: 'Keywords are required',
      // New translations for the updated external functionality
      addTitle: 'Add External Sources',
      editTitle: 'Edit External Source',
      addButton: 'Add External Sources',
      updateButton: 'Update External Source',
      item: 'External Source',
      url: 'URL',
      keywords: 'Keywords',
      listTitle: 'External Sources',
      items: 'items',
      emptyTitle: 'No external sources',
      emptyDescription: 'Add your first external source to get started.',
      createSuccess: 'External sources created successfully',
      createError: 'Error creating external sources: ',
      updateSuccess: 'External source updated successfully',
      updateError: 'Error updating external source: ',
      deleteSuccess: 'External source deleted successfully',
      deleteError: 'Error deleting external source: ',
      deleteSelectedSuccess: 'Selected external sources deleted successfully',
      loadError: 'Error loading external sources: ',
      loadMoreError: 'Error loading more external sources: ',
      status: {
        active: 'Active',
        processing: 'Processing',
        failed: 'Failed',
      },
      confirmDelete: 'Confirm Delete',
      confirmDeleteMessage: 'Are you sure you want to delete this external source? This action cannot be undone.',
      confirmDeleteMultiple: 'Confirm Delete Multiple',
      confirmDeleteMultipleMessage: 'Are you sure you want to delete the selected external sources? This action cannot be undone.',
      deleting: 'Deleting external source...',
      loading: 'Loading external sources...',
      lastFetched: 'Last fetched',
      chunks: 'chunks',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      update: 'Update',
      updating: 'Updating...',
    },
  },
  inbox: {
    loading: 'Loading...',
    error: 'An error occurred',
    noData: 'No data available',
    confirmDelete: 'Are you sure you want to delete this item?',
    deleteSuccess: 'Item deleted successfully',
    deleteError: 'Error deleting item',
    tickets: {
      title: 'Tickets',
      description: 'Manage support tickets from your customers',
      noTickets: 'No tickets available',
      notCreated: 'No tickets have been created yet.',
      confirmDelete: 'Are you sure you want to delete this ticket?',
      columns: {
        id: 'ID',
        requestedBy: 'Requested By',
        subject: 'Subject',
        description: 'Description',
        email: 'Email',
        status: 'Status',
        createdDate: 'Created Date',
        action: 'Action',
      },
      status: {
        new: 'New',
        send: 'Send',
      },
      priority: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
    },
    leads: {
      title: 'Leads',
      description: 'Manage leads from your customers',
      noLeads: 'No leads available',
      notCreated: 'No leads have been created yet.',
      confirmDelete: 'Are you sure you want to delete this lead?',
      searchPlaceholder: 'Search leads',
      connect: 'Connect',
      export: 'Export',
      columns: {
        email: 'Mail address',
        name: 'Name',
        signupDate: 'Signup Date',
        action: 'Action',
        topics: 'Topics'
      }
    },
    emailSetting: {
      title: 'Email setting',
      description: 'Setting email to send email to you when customer send feedback from chatbot',
      chatbotSelection: {
        title: '',
        description: 'Select a chatbot to configure email settings for receiving customer feedback',
        placeholder: 'Select chatbot',
        empty: 'No chatbots available'
      },
      form: {
        title: 'Email Configuration',
        description: 'Configure the email address where you want to receive customer feedback notifications',
        emailLabel: 'Enter email',
        emailPlaceholder: 'Enter your email',
        emailHint: 'Email address where customer feedback notifications will be sent',
        saveButton: 'Save'
      },
      success: {
        title: 'Success',
        saved: 'Email setting saved successfully'
      },
      error: {
        title: 'Error',
        loadFailed: 'Failed to load email setting',
        saveFailed: 'Failed to save email setting',
        noChatbotSelected: 'Please select a chatbot first',
        emailRequired: 'Email address is required',
        emailInvalid: 'Please enter a valid email address'
      },
      alert: {
        notImplemented: 'This feature is under development.\n\nYou are about to save email setting for:\nChatbot: {chatbot}\nEmail: {email}\n\nDo you want to proceed with the demo?',
        saveSuccess: 'Demo completed successfully!\n\nEmail setting saved for:\nChatbot: {chatbot}\nEmail: {email}\n\nNote: This is a demo version. In the full version, this will be saved to the database.',
        saveError: 'Demo save failed!\n\nPlease try again or contact support if the issue persists.'
      },
      info: {
        notImplemented: 'This feature is currently under development and not fully functional. This is a demo of the save process.'
      },
      noChatbot: {
        title: 'No chatbot selected',
        description: 'Please select a chatbot to configure email settings'
      }
    },
    common: {
      loading: {
        leads: 'Loading leads...',
        tickets: 'Loading tickets...',
        emailSetting: 'Loading email setting...',
        chatbots: 'Loading chatbots...'
      },
      actions: {
        delete: 'Delete',
        selectItem: 'Select {item}',
        resend: 'Resend'
      }
    },
  },
  analytics: {
    chats: 'Chats',
    topics: 'Topics',
    chatAnalytics: 'Chat Analytics',
    topPages: 'Top pages',
    dailyNumberOfChats: 'Daily number of chats',
    showAllTopics: 'Show all topics',
    hideAllTopics: 'Hide all topics',
    overview: 'Overview',
    totalChats: 'Total Chats',
    completionRate: 'Completion Rate',
    avgDuration: 'Avg. Duration',
    satisfaction: 'Satisfaction',
    chatTrends: 'Chat Trends',
    recentChats: 'Recent Chats',
    id: 'ID',
    user: 'User',
    date: 'Date',
    duration: 'Duration',
    status: 'Status',
    completed: 'Completed',
    abandoned: 'Abandoned',
    mostPopular: 'Most Popular Topics',
    products: 'Products',
    shipping: 'Shipping',
    returns: 'Returns',
    payment: 'Payment',
    account: 'Account',
    other: 'Other',
    topicTrends: 'Topic Trends',
    chartPlaceholder: 'Chart visualization will be displayed here',
    frequentQuestions: 'Most Frequent Questions',
    productAvailability: 'Product Availability Question',
    shippingTime: 'Shipping Time Question',
    discountCodes: 'Discount Codes Question',
    returnPolicy: 'Return Policy Question',
    paymentMethods: 'Payment Methods Question',
    questionFrequency: 'Asked {count} times this month',
    filterByDate: 'Filter by date',
    dateRange: 'Date range',
    selectDateRange: 'Select date range',
    allTime: 'All time',
    lastMonth: 'Last month',
    lastYear: 'Last year',
    totalMessages: 'Total Messages',
    productRecommendations: 'Product Recommendations',
    totalTopics: 'Total Topics',
    popularTopics: 'Popular Topics',
    topicDistribution: 'Topic Distribution',
    fromLastMonth: 'from last month',
    noDataAvailable: 'No data available',
    chartWillBeDisplayed: 'Chart visualization will be displayed here',
    topDomains: 'Top Domains',
    contents: 'Contents'
  },
  demo: {
    title: 'Language Switching Demo',
    currentLanguage: 'Current language',
    footer: 'The system now fully supports multilingual for English (EN) and German (DE)',
    sections: {
      sidebar: 'Sidebar Navigation',
      inbox: 'Inbox Module',
      data: 'Data Module',
      actions: 'Common Actions',
      account: 'Account Settings',
      analytics: 'Analytics'
    }
  },
  tenant: {
    // TenantInitializationModal
    progressSteps: 'Progress steps:',
    retry: 'Retry',
    retrying: 'Retrying...',
    continue: 'Continue to Login',

    // Status titles
    preparingInitialization: 'Preparing initialization...',
    initializingTenant: 'Initializing tenant',
    initializationSuccessful: 'Initialization successful!',
    initializationFailed: 'Initialization failed',
    processing: 'Processing...',


    // Status descriptions
    preparingDescription: 'System is preparing to initialize your tenant...',
    runningDescription: 'Please wait while we set up your account and data.',
    completedDescription: 'Your workspace has been initialized successfully! Click Continue to login and start using the service.',
    failedDescription: 'An error occurred during initialization. Please try again.',
    processingDescription: 'Processing your request...',

    // Progress steps
    modelReload: 'Model reload',
    creatingTypes: 'Creating types',
    creatingRootItems: 'Creating root items',
    creatingRelations: 'Creating relations',
    creatingAttributes: 'Creating attributes',
    createNewAccount: 'Create new account',
    initializingWorkspace: 'Initializing workspace...',

    setupFailed: 'Setup failed',
    incompleteSetupDetected: 'Incomplete setup detected',




    // Messages
    initializingTenantMessage: 'Initializing tenant...',
    initializationProgress: '{step}... ({completed}/{total} completed)',
    initializationTimeout: 'Initialization timeout. Logging out...',
    statusCheckError: 'Cannot check initialization status. Logging out...',
    statusPollingError: 'Error checking initialization status. Logging out...',
    reinitializingWorkspace: 'Re-initializing workspace...',
    reRegistrationFailed: 'Failed to restart workspace setup. Please contact support.',
    retryCriticalError: 'A critical error occurred while retrying.',
    setupWorkspaceError: 'We could not set up your workspace automatically. Please retry.',
    creatingWorkspace: 'Creating workspace...',
    workspaceSetupComplete: 'Workspace setup completed successfully!',
    accountCleanedUpDueToFailure: 'Account cleaned up due to setup failure'
  },

  messageSection: {
    title: 'Messages',
    chatboxTitle: 'Chatbox Title',
    welcomeMessage: 'Welcome Message',
    welcomeMessageHint: 'Enter a welcome message for your chatbot.',
    suggestedMessages: 'Suggested Messages',
    suggestedMessagesHint: 'Enter suggested messages, one per line.',
    messagePlaceholder: 'Message Placeholder',
    welcomeCardStyle: 'Welcome Card Style',

  },

  welcomeMessageSection: {
    title: 'Welcome Message',
    welcomeMessage: 'Welcome Message',
    welcomeMessageHint: 'Enter a welcome message for your chatbot. You can use HTML for formatting.',
    welcomeMessageStyle: 'Welcome Message Style',
    welcomeMessageStyle1: 'Style 1 - Simple Message',
    welcomeMessageStyle2: 'Style 2 - Modern Message',
    welcomeMessageBackground: 'Welcome Message Background',
    autoShowWelcome: 'Auto show welcome messages pop-ups after',
    seconds: 'seconds',
    negativeToDisable: '(negative to disable)'
  },

  suggestedMessage: {
    placeholder: 'Enter suggested message',
    remove: 'Remove this message',
    empty: 'No suggested messages yet. Add some to help users start a conversation.',
    add: 'Add suggested message'
  },
  conversationalStyle: {
    title: 'Conversational Style',
    style: 'Style',
    friendly: 'Friendly',
    professional: 'Professional',
    casual: 'Casual',
    creative: 'Creative',
    learnFromUrl: 'Learn from URL',
    useEmojis: 'Use Emojis'
  },
  visualAppearance: {
    title: 'Visual Appearance',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    avatarImage: 'Avatar Image',
    chatIcon: 'Chat Icon',
    botMessageColor: 'Bot Message Color',
    userMessageColor: 'User Message Color',
    chatboxHeaderColor: 'Chatbox Header Color',
    chatButtonColor: 'Chat Button Color',
    chatAlignment: 'Chat Alignment',
    bubbleAlignment: 'Chatbox Bubble Alignment',
    left: 'Left',
    right: 'Right'
  },
  avatarManage: {
    support: 'Supports JPG, PNG, and SVG files up to 1 MB',
    upload: 'Upload Image',
    pasteUrl: 'Paste URL',
    remove: 'Remove'
  },
  choiceColor: {
    reset: 'Reset',
    hexValue: 'Hex Value',
    apply: 'Apply'
  },
  miscellaneous: {
    title: 'Miscellaneous',
    autoShowWelcome: 'Automatically show welcome message popups after',
    seconds: 'Seconds',
    negativeToDisable: '(negative to deactivate)'
  },

  backgroundImage: {
    support: 'Supports JPG, PNG, and SVG files up to 2MB. Image will be displayed in original aspect ratio.',
    apply: 'Apply',
    cancel: 'Cancel',
    clickToUpload: 'Click to upload',
    orDragImageHere: 'or drag image here',
    upload: 'Upload Image',
    pasteUrl: 'Paste URL',
  },

  tour: {
    back: 'Back',
    skip: 'Skip',
    next: 'Next',
    finish: 'Finish',
    steps: {
      chatbotList: {
        content: 'This section shows all your chatbots. You can manage and edit them from here.',
      },
      dataStats: {
        content: 'View your data statistics including products, content, and training progress.',
      },
      createChatbot: {
        content: 'Click here to create a new chatbot and start the setup wizard.',
        timelineStep1: 'Step 1: Provide basic information for your chatbot, such as a name and description.',
        timelineStep2: 'Step 2: Add data sources, like your website URL or sitemap, to train your chatbot.',
        timelineStep3: 'Step 3: Customize the look and feel of your chat interface to match your brand.',
        infoCard: 'Enter a name and description for your chatbot here. This will help you identify it later.',
      },
    },
  }
}